import {
  Box,
  Heading,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from '@chakra-ui/react';
import NotificationSettingsTab from './settings/NotificationSettingsTab';
import ApiIntegrationTab from './settings/ApiIntegrationTab';

const Settings = () => {
  return (
    <Box p={6} flex="1" minH="100vh" bg="gray.100">
      <Heading display="flex" alignItems="center" mb={6}>
        Configurações
      </Heading>

      <Tabs colorScheme="teal" variant="enclosed">
        <TabList>
          <Tab fontWeight="semibold">Notificações</Tab>
          <Tab fontWeight="semibold">Integrar API de Infrações</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <NotificationSettingsTab />
          </TabPanel>
          <TabPanel>
            <ApiIntegrationTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default Settings;
